import { MBO_STUDIES, HBO_STUDIES, UNIVERSITEIT_STUDIES } from './studies'

export const STUDIES_BY_LEVEL = {
  ...MBO_STUDIES,
  ...HBO_STUDIES,
  ...UNIVERSITEIT_STUDIES
}
